import { createContext } from 'react'

import { WizardContextProps } from './WizardContext.types'

export const WizardContext = createContext<WizardContextProps | undefined>(undefined)
